import React from "react";
import css from "../style/Home.module.css";

const Home = () => {
    return (
        // <section className="bg-primary text-light pt-3 text-center text-sm-start" id="home">
        <section className={css.heroSection} id="home">
            <div className={css.gradientBlob1}></div>
            <div className={css.gradientBlob2}></div>
            <div className={css.gradientBlob3}></div>
            <div className="container position-relative">
                <div className="d-md-flex justify-content-between">
                    <div className="text-info d-flex col-md-5 flex-column justify-content-center">
                        <h2>Hi, I'm <span class="text-secondary">Sammy Lee</span></h2>
                        <p>Software Developer based in Boston</p>
                        <div className="mb-4 mb-md-0">
                            <a href="https://www.linkedin.com/in/sammy-lee8068/" className="" style={{textDecoration: 'none', color: "#DCE6FC"}}>
                                <i class="devicon-linkedin-plain me-3" style={{fontSize: '30px'}}></i>
                            </a>
                            <a href="https://github.com/Sammy2023" style={{textDecoration: 'none', color: "#DCE6FC"}}>
                                <i class="devicon-github-original" style={{fontSize: '30px'}}></i>
                            </a>
                        </div>
                    </div>
                    <div className="d-flex col-md-6 justify-content-center py-4">
                        <img
                            src={require('../assets/profile.jpeg')}
                            alt="Sammy Lee"
                            className={css.profileImage}
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Home;